<template>
  <v-table-number-input v-bind="props" :originCurrencyId="originCurrencyId" :subject="subject" @onNext="onEnter" @cancelEdit="cancelEdit" v-if="editing && !readonly"/>
  <div v-else class="v-table-number" :class="number<0?'red-color':''" @click="doEdit" style="position:relative;">
    <span v-for="n in numberStrList">{{ n }}</span>
    <div class="origin-number"  v-if="!readonly && originCurrency && originCurrency.id!=localCurrency.id">

      <div class="origin-number-label" v-if="!readonly && numberFor && originCurrency.name">
        <span v-for="n in Array.from(originCurrency.name)">{{ n }}</span>
        <span v-if="numberForStrList.length>0">:</span>
      </div>
      <span v-for="n in numberForStrList">{{ n }}</span>
    </div>
  </div>
</template>

<script setup>
import {computed, defineEmits, defineProps, ref, watch} from "vue";
import {floor, multiply, padStart, toNumber} from "xe-utils";
import VTableNumberInput from "@components/VoucherTable/VTableNumberInput.vue";
import {toNumberString} from "number-string";
import {useStore} from "vuex";

const emits = defineEmits(['cancelEdit', 'onEnter']);

const props = defineProps({
  number: {
    type: [Number, String]
  },
  numberFor: {
    type: [Number, String]
  },
  exchangeRate: {
    type: [Number, String]
  },
  readonly: {
    type: Boolean,
    default: false
  },
  originCurrencyId: [String, null],
  rowIndex: Number,
  field: String,
  subject: Object,
});
//编辑
const editing = ref(false)
const number = ref(props.number || null);
const numberFor = ref(props.numberFor || null);
const originCurrency = ref(null);
const exchangeRate = ref(props.exchangeRate || null);

const store = useStore();
const {localCurrency} = store.getters

const currencyMap = store.state.currencyMap;

let hasWb = ref(false)
if(props.subject && props.subject.currencyAccounting && props.subject.currencyAccounting.length){
  hasWb.value = true;
}

watch(() => props.number, (val) => {
  number.value = val || null;
})

watch(() => props.numberFor, (val) => {
  numberFor.value = val || null;
})

watch(() => props.originCurrencyId, (val) => {
  if(val){
    originCurrency.value= currencyMap[val];
  }
})


const numberStrList = computed(() => {
  if (number.value || number.value === 0) {
    let num = number.value;
    if (typeof num === 'string') {
      num = toNumber(number.value);
    }
    num = Math.abs(num);
    if (num === 0 || num <= 9999999999.99 && num >= 0.01) {
      let str = toNumberString(floor(multiply(num, 100), 0));
      return str.split("");
    }
    return padStart('金额超过显示范围', 11, ' ').split("")
  }
  return [];
})

const numberForStrList = computed(() => {
  if (numberFor.value || numberFor.value === 0) {
    let num = numberFor.value;
    if (typeof num === 'string') {
      num = toNumber(numberFor.value);
    }
    num = Math.abs(num);
    if (num === 0 || num <= 9999999999.99 && num >= 0.01) {
      let str = toNumberString(floor(multiply(num, 100), 0));
      return str.split("");
    }
    return padStart('金额超过显示范围', 11, ' ').split("")
  }

  return [];
})

const doEdit = () => {
  editing.value = true;
}

const cancelEdit = (params) => {
  editing.value = false;
  number.value = params.number;
  numberFor.value = params.numberFor;
  originCurrency.value = params.originCurrency;
  exchangeRate.value = params.exchangeRate;
  emits('cancelEdit', params)
}

const onEnter = (params) => {

  cancelEdit(params);
  emits('onEnter', params)
}

defineExpose({
  doEdit,
  cancelEdit
})
</script>
<style scoped lang="less">
.v-table-number {
  line-height: 60px;
  background-image: url("../../assets/moneyUint2.png");
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  height: 100%;

  span {
    display: inline-block;
    text-align: center;
    width: 20px;
    height: 100%;
    font-size: 15px;
    font-weight: bold;
  }

  .origin-number-label {
    position:absolute;
    top:0px;
    left:-60px;
    fot-size:10px;
    color:#509bf3;
    font-weight:500;

    span {
      font-size: 10px;
      font-weight: normal;
    }
  }

  .origin-number {
    position:absolute;
    top:30px;
    color:#509bf3;
    font-weight:500;

    span {
      font-size: 12px;
      font-weight: normal;
    }
  }
}
</style>
